import { useCallback } from 'react';

import { useResetRecoilState } from 'recoil';

import { automaticDebitData } from '../pages/PaymentLink/components/PaymentContent/AutomaticDebit/store/atoms/automaticDebitData';
import { nupayData } from '../pages/PaymentLink/components/PaymentContent/Nupay/store/atoms/nupayData';
import { pixData } from '../pages/PaymentLink/components/PaymentContent/Pix/store/atoms/pixData';
import { acceptedAccessionTermsAtom } from '../store/AccessionTerms/atoms/acceptedAccessionTerms';
import { isDocumentAuthenticated } from '../store/isDocumentAuthenticated/atoms/isDocumentAuthenticated';
import { paymentMethodChangeAcceptance } from '../store/PaymentMethodChangeAcceptance/atoms/paymentMethodChangeAcceptance';

/**
 * Esses atoms do Recoil vivem a sessão inteira do SPA, e no carrinho o cliente compra duas
 * vezes sem recarregar. Fica de fora o que é do cliente, e não da compra.
 *
 * Só limpe quando o orçamento muda: limpar a cada montagem apaga um Pix já gerado.
 */
export default function useResetCheckoutState() {
  const resetPixData = useResetRecoilState(pixData);
  const resetNupayData = useResetRecoilState(nupayData);
  const resetAutomaticDebitData = useResetRecoilState(automaticDebitData);
  const resetAcceptedAccessionTerms = useResetRecoilState(
    acceptedAccessionTermsAtom,
  );
  const resetIsDocumentAuthenticated = useResetRecoilState(
    isDocumentAuthenticated,
  );
  const resetPaymentMethodChangeAcceptance = useResetRecoilState(
    paymentMethodChangeAcceptance,
  );

  return useCallback(() => {
    resetPixData();
    resetNupayData();
    resetAutomaticDebitData();
    resetAcceptedAccessionTerms();
    resetIsDocumentAuthenticated();
    resetPaymentMethodChangeAcceptance();
  }, [
    resetPixData,
    resetNupayData,
    resetAutomaticDebitData,
    resetAcceptedAccessionTerms,
    resetIsDocumentAuthenticated,
    resetPaymentMethodChangeAcceptance,
  ]);
}
